import { IconButton } from '@/components/Buttons';
import { Spinner } from '@/components/Loader/Spinner';
import isEqual from 'lodash/isEqual';
import { memo } from 'react';
import { StyleSheet } from 'react-native';
import { View } from "@/components/Theme";
import { Image } from 'expo-image';

const CarouselVideo = ({path, dimension, thumbnails, thumbnailStyle, showPlus}) => (
    <View style={styles.videoWrapper}>
        <Image 
            resizeMethod={'resize'} 
            source={{uri: path + '.thumb.jpg'}}
            fallbackSource={{uri: path}} 
            contentFit={thumbnails ? 'cover' : 'contain'}
            style={[styles.imageStyle, {width: dimension.width, height: dimension.height}, thumbnailStyle]} 
            PlaceholderContent={<Spinner />} 
        />
        <View style={styles.videoPlay}>
            <IconButton size={50} style={styles.videoPlayIcon} color={'black'} icon={'circle-play'} />
        </View>

        {showPlus && 
            <View style={styles.plus}>
                <IconButton size={20} style={styles.plusIcon} color={'black'} icon={'circle-plus'} />
            </View>
        }
    </View>
);

const styles = StyleSheet.create({
    videoWrapper: {
        position: 'relative', 
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    videoPlay: {
        zIndex: 99, 
        position: 'absolute', 
        alignSelf: 'center', 
        marginTop: -25,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: 100,  
    },
    plus: {
        zIndex: 99, 
        position: 'absolute', 
        alignSelf: 'center', 
        justifyContent: 'center',
        alignItems: 'center',
        
        width: 30,
        height: 30,
        right: 5,
        bottom: 5,
        borderRadius: 100,  
        opacity: .9
    },
    plusIcon: {
        color:'white'
    },
    videoPlayIcon: {
        color:'white'
    },
    imageStyle: {
        justifyContent: 'center', 
        alignItems: 'center'
    }
});

export default memo(CarouselVideo, (prevProps, nextProps) => isEqual(prevProps, nextProps));